import imageCompression from 'browser-image-compression';

// Compresses an image File before upload. The server compresses again as a
// safety net, but doing it here saves bandwidth — important on mobile data.
export async function compressImage(file) {
  if (!file || !file.type.startsWith('image/')) return file;
  try {
    const compressed = await imageCompression(file, {
      maxSizeMB: 0.6,           // target ~600KB
      maxWidthOrHeight: 1600,   // matches server MaxDimension
      useWebWorker: true,
      fileType: 'image/jpeg',
      initialQuality: 0.7,
    });
    // Ensure a sensible filename/extension.
    const name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([compressed], name, { type: 'image/jpeg' });
  } catch (e) {
    console.warn('Compression failed, uploading original:', e);
    return file;
  }
}

export function humanSize(bytes) {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
